import { Injectable, inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root',
})
export class SnackbarService {
  private snackBar = inject(MatSnackBar);

  showSuccess(message: string) {
    this.showSnackbar(message, true);
  }
  showError(message: string) {
    this.showSnackbar(message, false);
  }
  private showSnackbar(message: string, isGood: boolean) {
    const snackbarRef = this.snackBar.open(message, '', {
      duration: 0,
      horizontalPosition: 'left',
      verticalPosition: 'bottom',
      panelClass: isGood ? ['success-snackbar'] : ['error-snackbar'],
    });
    document.addEventListener(
      'click',
      () => {
        if (snackbarRef) {
          snackbarRef.dismiss();
        }
      },
      { once: true }
    );
  }
}
